import _ from 'lodash';
window._ = _;

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

// Initialize Popper v2 (required by Bootstrap 5)
import * as Popper from '@popperjs/core';
window.Popper = Popper; // Make Popper v2 available globally

// Keep tippy.js
import tippy, { followCursor } from 'tippy.js';
window.tippy = tippy;
window.tippyFollowCursor = followCursor;

// Keep jQuery (Bootstrap 5 doesn't require it, but other parts of your app might)
import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;

// Load Bootstrap 5 normally
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

// Log Bootstrap version info for debugging
console.log('Bootstrap loaded with type:', typeof window.bootstrap.Dropdown);

// Note: jQuery.fn.dropdown might be defined by Bootstrap 5 for backwards compatibility
// This is expected behavior when jQuery is present before Bootstrap 5 loads
if ($.fn.dropdown) {
    console.log('jQuery.fn.dropdown is defined - this is normal when jQuery is loaded before Bootstrap 5');
}

// Commented DataTables imports (keep these commented)
// import 'datatables.net';
// import 'datatables.net-bs5';
// import 'datatables.net-select';
// import 'datatables.net-select-dt';
// import 'datatables.net-responsive';
// import 'datatables.net-buttons';
// import 'datatables.net-buttons-dt';
// import 'datatables.net-buttons-bs5';


/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next, we will ensure Axios has the CSRF token for all requests.
 * This is needed to prevent 419 errors when making AJAX requests.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
    console.log('CSRF token successfully set for Axios:', token.content);
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';
// import Pusher from 'pusher-js';
// window.Pusher = Pusher;

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: import.meta.env.VITE_PUSHER_APP_KEY,
//     cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
